export const API_KEY = 'AIzaSyDfGZ8CYBUoJg0P6fnQZZuOGvdq4-K0BC0';